<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M5.3 16.165V3.835H10.42C12.666 3.835 14 5.05 14 6.92V6.94C14 8.22 12.98 9.36 11.7 9.52V9.56C13.28 9.71 14.5 10.925 14.5 12.66V12.68C14.5 14.81 12.97 16.165 10.47 16.165H5.3ZM9.86 5.55H7.5V9.05H9.49C10.98 9.05 11.75 8.39 11.75 7.24V7.22C11.75 6.14 10.98 5.55 9.86 5.55ZM9.83 10.64H7.5V14.448H10.03C11.58 14.448 12.39 13.74 12.39 12.51V12.49C12.39 11.26 11.48 10.64 9.83 10.64Z"
            fill="currentColor"
        />
    </svg>
</template>
